import React from 'react';
import ReasonsView from './ReasonsView';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';

export default class ReasonsContainer extends React.Component {

  constructor() {
    super();
    this.state = { hasFetched: false };
  }

  componentDidMount() {
    const URL = `../api/starfish/success-network/services/${this.props.id}/appointment-reasons`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(({appointmentReasons, recurring}) => this.props.onReasonsFetched(appointmentReasons, recurring))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <ReasonsView
        {...this.state}
        serviceName={this.props.serviceName}
        appointmentReasons={this.props.appointmentReasons}
        value={this.props.value}
        onReasonSelected={this.props.onReasonSelected}
      />
    );
  }
}

ReasonsContainer.propTypes = {
  appointmentReasons: PropTypes.array,
  onReasonsFetched: PropTypes.func.isRequired,
  id: SFEntityID.isRequired,
  serviceName: PropTypes.string.isRequired,
  value: SFEntityID,
  onReasonSelected: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired
};
